export const AB_MENU_QP_STORAGE_KEY = 'menu-query-params'
export const AB_REPORT_SCHEDULER = 'report-scheduler'
export const AB_MAP_COMPARISON_MODE = 'map-comparison-mode'
